import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Pagination,
  Popover,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useDriverFinancialController } from './controller';
import { DriverFinancialModel } from '../../models/driverFinancial';
import { numberFormat } from '../../utils/nunberFormat';
import { DEFAULT_ROWS_PER_PAGE } from '../../config-global';
import TableSearchNotFound from '../../components/tableSearchNotFound';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import blue from '../../assets/images/driver-financial/blue.svg';
import clock from '../../assets/images/driver-financial/clock.svg';
import mark from '../../assets/images/driver-financial/mark.svg';
import DetailDriverFinancial from './detial';
import LogoutIcon from '@mui/icons-material/Logout';
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import TabDriverFinancialComponent from './components/tabPanelComponents';
import { convertDateStringToNormalDateTime, convertDateStringToNormalString } from '../../utils/convertDateFormat';
import PaidStatusChip from './components/statusPaid';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import { findOrderCreateTime } from '../../utils/findOrderCreareTime';
import TabRiderDayComponents from './components/tabRiderDay';
import { MonthEnum } from '../../enums/monthEnum';
import { ConvertMonthTypeToNormalString } from '../../utils/convertMonthToNormalString';
import { findYearsDataFrom2023 } from '../../utils/findYearDataFrom2023';
import { DriverFinancialEnum } from '../../enums/driverFinancailEnum';
import ButtonExportCsv from '../../components/ButtonExportCsv';
import { RIDER_BALANCE_HEADER } from './csvHeader/cavHeader';
import { totalDistance } from '../../utils/sumTotalDistance';

const DriverFinancialView = () => {
  const { t } = useTranslation('global');

  const controller = useDriverFinancialController();

  const tableHeaders: string[] = [
    t('No.'),
    t('Full Name'),
    t('Phone number'),
    t('Branch'),
    t('Role'),
    t('Verified'),
    t('Status'),
  ];
  //
  return (
    <>
      {controller.openForm ? (
        <DetailDriverFinancial onClose={controller.handleCloseForm} selectedData={controller.selectedData} onFetchData={controller.handleFetchData} financialType={controller.tabDriverFinancial} />
      ) : (
        <>
          {
            controller.loadingData ?
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingAnimatedIcon />
              </Box> :
              <>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                    <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("paymentMoney_page.Payment Money Rider")}</Typography>
                    <Box sx={{ ml: 1, width: 'auto' }}>
                      <TextField
                        placeholder={`${t("driverFinancial_page.Search by driver")}`}
                        size="small"
                        fullWidth
                        value={controller.searchValue}
                        onChange={controller.handleSearch}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                {/* <Card
                  sx={{
                    boxShadow:
                      '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    p: 2,
                    borderRadius: '16px',
                    mt: 4,
                    mb: 4,
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            justifyContent: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              position: 'relative',
                              display: 'inline-flex',
                            }}
                          >
                            <CircularProgress
                              variant="determinate"
                              value={75}
                              size={53}
                              thickness={2}
                              sx={{
                                strokeLinecap: 'round',
                                color: '#00b8d9',
                              }}
                            />
                            <img
                              src={blue}
                              alt="blue"
                              style={{
                                position: 'absolute',
                                top: 14,
                                left: 14,
                                width: 25,
                                height: 25,
                              }}
                            />
                          </Box>
                          <Box sx={{ ml: 2 }}>
                            <Box>
                              <Typography variant="h6">ໃບບີນເກັບເງີນທັງໜົດ</Typography>
                            </Box>
                            <Box>
                              <Typography>{controller.allInvoice} {t("driverFinancial_page.invoices")}</Typography>
                            </Box>
                            <Box>
                              <Typography>{numberFormat(controller.totalAllInvoiceMoney)} {t("driverFinancial_page.Kip")}</Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            justifyContent: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              position: 'relative',
                              display: 'inline-flex',
                            }}
                          >
                            <CircularProgress
                              variant="determinate"
                              value={75}
                              size={53}
                              thickness={2}
                              sx={{
                                strokeLinecap: 'round',
                                color: '#FFAB00',
                              }}
                            />
                            <img
                              src={clock}
                              alt="clock"
                              style={{
                                position: 'absolute',
                                top: 14,
                                left: 14,
                                width: 25,
                                height: 25,
                              }}
                            />
                          </Box>
                          <Box sx={{ ml: 2 }}>
                            <Box>
                              <Typography variant="h6">ຈຳນວນເງີນທີ່ຈ່າຍໃຫ້ໄລເດີ້ທັງໜົດ</Typography>
                            </Box>
                            <Box>
                              <Typography>{controller.allPayRider?.length} {t("driverFinancial_page.invoices")}</Typography>
                            </Box>
                            <Box>
                              <Typography>{numberFormat(controller.totalMoneyPayRider)} {t("driverFinancial_page.Kip")}</Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            justifyContent: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              position: 'relative',
                              display: 'inline-flex',
                            }}
                          >
                            <CircularProgress
                              variant="determinate"
                              value={75}
                              size={53}
                              thickness={2}
                              sx={{
                                strokeLinecap: 'round',
                                color: '#36B37E',
                              }}
                            />
                            <img
                              src={mark}
                              alt="mark"
                              style={{
                                position: 'absolute',
                                top: 14,
                                left: 14,
                                width: 25,
                                height: 25,
                              }}
                            />
                          </Box>
                          <Box sx={{ ml: 2 }}>
                            <Box>
                              <Typography variant="h6">ໃບບີນສຳເລັດທັງໜົດ</Typography>
                            </Box>
                            <Box>
                              <Typography>{controller.allPaidMoney?.length} {t("driverFinancial_page.invoices")}</Typography>
                            </Box>
                            <Box>
                              <Typography>{numberFormat(controller.totalPaidMoney)} {t("Kip")}</Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Card> */}
                <Box sx={{ mt: 2 }}>
                  <Box mt={1} mb={1} sx={{ display: 'flex', justifyContent: 'right' }}>
                    <ButtonExportCsv loading={false} onClick={() => {
                      if (controller.buttonExportCsv.current) {
                        controller.buttonExportCsv.current.link.click();
                      }
                    }} buttonRef={controller.buttonExportCsv} title='Export Rider csv' data={controller.getDataExportCsv} filename='Rider Balance' headers={RIDER_BALANCE_HEADER} />
                  </Box>

                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ background: '#f7f7f7' }}>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.No")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Rider Name")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Number of Clearance")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Total Money")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Total Money Round")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.District Rider Got")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Total Money")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Clearance Time")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          controller.rows?.map((row: DriverFinancialModel, index: number) => {
                            const { id, rider, createdAt, balanceSubmission, ordersCash, ordersOnePay, totalMoneyRiderGot, ordersReturn } = row;
                            const distanceOrderCash = ordersCash?.orders?.map((item) => item?.distance)
                            const distanceOrderOnePay = ordersOnePay?.orders?.map((item) => item?.distance)
                            const distanceOrderReturn = ordersReturn?.orders?.map((item) => item?.distance)
                            const distanceRiderGot = totalDistance(distanceOrderCash, distanceOrderOnePay, distanceOrderReturn)

                            return (
                              <TableRow key={index}>
                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                  {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controller.page - 1))}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{rider?.username}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{balanceSubmission?.length}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}><span>{numberFormat(rider?.totalMoneyRiderCantake)}</span> {t("Kip")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}> <span style={{ color: 'red' }}>{numberFormat(totalMoneyRiderGot)}</span> {t("Kip")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{distanceRiderGot?.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {numberFormat(
                                    balanceSubmission?.reduce((total, item) => total + (item?.totalMoney || 0), 0)
                                  )} {t("Kip")}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{convertDateStringToNormalDateTime(createdAt)}</TableCell>
                                <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                  <IconButton
                                    size="large"
                                    color="inherit"
                                    onClick={(e: any) => controller.handleOpenMenu(e, id)}
                                  >
                                    <MoreHorizIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )
                          })
                        }
                      </TableBody>
                      {controller.isSearchNotFound && (
                        <TableSearchNotFound
                          searchValue={controller.searchValue}
                          colSpan={tableHeaders.length + 1}
                        />
                      )}
                    </Table>
                  </TableContainer>
                  <Divider />
                  <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                    <Pagination
                      color="primary"
                      page={controller.page}
                      onChange={controller.handleChangePage}
                      count={controller.countPagination}
                    />
                  </Box>
                </Box>
              </>
          }
          <Popover
            open={Boolean(controller.openMenu)}
            anchorEl={controller.openMenu}
            onClose={controller.handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            <MenuItem onClick={controller.handleOpenForm}>
              &nbsp;&nbsp;
              {t('See Detail')}
            </MenuItem>
          </Popover>
        </>
      )}
    </>
  );
};
export default DriverFinancialView;
